module.exports = __webpack_public_path__ + "img/pdf.3c9dc0a7.svg";